module.exports = __webpack_public_path__ + "img/zuijia_52.25d741ad.png";